<template>
  <div class="email-box">
    <form @submit.prevent="handleSubmit" novalidate>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div class="relative">
          <input
            type="text"
            v-model="formData.firstName"
            placeholder="First Name *"
            class="w-full p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#02469c] focus:border-transparent"
            :class="['input-control', errors.firstName ? 'input-error' : '']"
            @input="clearError('firstName')"
          />
          <span
            v-if="errors.firstName"
            class="text-red-500 text-[12px] absolute -bottom-4 left-0 leading-none"
            >{{ errors.firstName }}</span
          >
        </div>
        <div class="relative">
          <input
            type="text"
            v-model="formData.lastName"
            placeholder="Last Name *"
            class="w-full p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#02469c] focus:border-transparent"
            :class="['input-control', errors.lastName ? 'input-error' : '']"
            @input="clearError('lastName')"
          />
          <span
            v-if="errors.lastName"
            class="text-red-500 text-[12px] absolute -bottom-4 left-0 leading-none"
            >{{ errors.lastName }}</span
          >
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div class="relative">
          <input
            type="email"
            v-model="formData.email"
            placeholder="Email *"
            class="w-full p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#02469c] focus:border-transparent"
            :class="['input-control', errors.email ? 'input-error' : '']"
            @input="clearError('email')"
          />
          <span
            v-if="errors.email"
            class="text-red-500 text-[12px] absolute -bottom-4 left-0 leading-none"
            >{{ errors.email }}</span
          >
        </div>

        <div class="relative">
          <input
            type="text"
            v-model="formData.phone"
            placeholder="WhatsApp/Phone *"
            class="w-full p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#02469c] focus:border-transparent"
            :class="['input-control', errors.phone ? 'input-error' : '']"
            @input="clearError('phone')"
          />
          <span
            v-if="errors.phone"
            class="text-red-500 text-[12px] absolute -bottom-4 left-0 leading-none"
            >{{ errors.phone }}</span
          >
        </div>
      </div>
      <div class="flex mb-6 relative">
        <input
          type="text"
          v-model="formData.country"
          placeholder="Country *"
          class="flex-1 p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#02469c] focus:border-transparent"
          :class="['input-control', errors.country ? 'input-error' : '']"
          @input="clearError('country')"
        />
        <span
          v-if="errors.country"
          class="text-red-500 text-[12px] absolute -bottom-4 left-0 leading-none"
          >{{ errors.country }}</span
        >
      </div>
      <div class="flex mb-6 relative">
        <input
          type="text"
          v-model="formData.zip"
          placeholder="zip *"
          class="flex-1 p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#02469c] focus:border-transparent"
          :class="['input-control', errors.zip ? 'input-error' : '']"
          @input="clearError('zip')"
        />
        <span
          v-if="errors.zip"
          class="text-red-500 text-[12px] absolute -bottom-4 left-0 leading-none"
          >{{ errors.zip }}</span
        >
      </div>

      <div class="relative">
        <textarea
          v-model="formData.message"
          placeholder="Message *"
          rows="6"
          class="w-full p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#02469c] focus:border-transparent"
          :class="[
            'input-control resize-none',
            errors.message ? 'input-error' : ''
          ]"
          @input="clearError('message')"
        ></textarea>
        <span
          v-if="errors.message"
          class="text-red-500 text-[12px] absolute -bottom-4 left-0 leading-none"
          >{{ errors.message }}</span
        >
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="bg-primary text-white px-16 py-3 mt-16 rounded font-bold hover:bg-blue-800 transition uppercase tracking-widest"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'EmailSubmit',
  components: {},
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        zip: '',
        message: ''
      },
      errors: {}
    }
  },
  methods: {
    validateForm() {
      const errs = {}
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (!this.formData.firstName.trim()) errs.firstName = 'Required'
      if (!this.formData.lastName.trim()) errs.lastName = 'Required'
      if (!this.formData.email.trim()) {
        errs.email = 'Required'
      } else if (!emailRegex.test(this.formData.email)) {
        errs.email = 'Invalid email format'
      }
      if (!this.formData.phone.trim()) errs.phone = 'Required'
      if (!this.formData.country.trim()) errs.country = 'Required'
      if (!this.formData.zip.trim()) errs.zip = 'Required'
      if (!this.formData.message.trim()) errs.message = 'Required'
      this.errors = errs
      return Object.keys(errs).length === 0
    },
    clearError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field)
      }
    },
    handleSubmit() {
      if (this.validateForm()) {
        // alert('Success! Your message has been sent.')
        this.$api.sysApi
          .sendEmail(this.formData)
          .then((res) => {
            alert('Success! Your message has been sent.')
            // this.submitStatus = 'success'
            setTimeout(() => {
              // 成功后清空表单
              Object.keys(this.formData).forEach(
                (key) => (this.formData[key] = '')
              )
            }, 3000)
          })
          .catch((err) => {
            console.log(err)
            alert('Error!')
            // this.submitStatus = 'error'
            setTimeout(() => {
              // this.submitStatus = ''
            }, 2000)
          })
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/emailform/Email.vue